import React from 'react';

const Pagination = ({
  postsPerView,
  totalPosts,
  paginate,
  currentPage,
  totalPages,
}) => {
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(totalPosts / postsPerView); i++) {
    pageNumbers.push(i);
  }

  return (
    <div className='pagination'>
      <div className='pagination__left'>
        <p>
          Showing {currentPage} of {totalPages}
        </p>
      </div>
      <div className='pagination__right'>
        {pageNumbers.map((el) => (
          <>
            {/* <button className='pagination__right__btn active-pagination'>
                    1
                  </button> */}
            <button
              key={Math.random()}
              className={`pagination__right__btn ${
                currentPage === el ? 'active-pagination' : ''
              }`}
              onClick={() => {
                paginate(el);
              }}
            >
              {el}
            </button>
          </>
        ))}
        {/* <button className='pagination__right__btn-next'>Next</button> */}
      </div>
    </div>
  );
};

export default Pagination;
